module.exports = "https://la-static.vkplay.ru/promo/newstart/img/intro-logo.5a93d785.png";